import type { IconSvgObject } from './types';

const ChevronsUpIcon: IconSvgObject = [
  ["path", { d: "M7 18C7 18 10.6824 13 12 13C13.3176 13 17 18 17 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 11C7 11 10.6824 6.00001 12 6C13.3176 5.99999 17 11 17 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsUpIcon;
